import React from 'react';
import ContainerValidation from "../../External/Components/ContainerValidation";
import HeaderValidation from "../../External/Components/HeaderValidation";
import {TAB_INDEX} from "../../External/Model/Model";
import BodyValidation from "../../External/Components/BodyValidation";
import StepContainerRequestAccess from "../Steps/StepContainerRequestAccess";
import FindMySelfMainApp from "../Functionality/FindMySelfMainApp";
import CommonQrRequestAccessApp from "../Functionality/CommonQrRequestAccessApp";

/**
 *
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 */
const FindMySelfMain = () => {
    const props = CommonQrRequestAccessApp( { } );
    const {
        t,
        navigate,
        btnDisabled,
        steps, setSteps,
        activeStep, setActiveStep,
        visitorList, setVisitorList,
        employeeList, setEmployeeList,
        emptyFields,
        photoPickerFile, setPhotoPickerFile,
        requestAccessItem,
        showLoader,
        handleChange,
    } = props;

    const {
        handleClickNext,
        handleNavigateBack
    } = FindMySelfMainApp(props);

    if(!activeStep || !steps) return <></>;

    return (<>
        <>
            <ContainerValidation>
                <HeaderValidation
                    activeStep={activeStep}
                    steps={steps?.TOTAL + 1}
                    click={()=>{
                        handleNavigateBack()
                    }}
                    showBtnBack={activeStep !== TAB_INDEX.FOUR}
                    headerCenter={
                        <div className="d-flex flex-column flex-sm-row justify-content-center align-items-center align-self-center gap-1">
                            <p className="fs-16-to-14 ibl-font-w-600 font-color-general-950 text-center">{t("request_access")}</p>
                            <p className="fs-16-to-14 ibl-font-w-600 font-color-general-950 d-none d-sm-block">{"•"}</p>
                            <p className="fs-16-to-12 ibl-font-w-400 font-color-general-950 text-center">{`${t("step")} ${activeStep} ${t("of")} ${steps?.TOTAL} `}</p>
                        </div>
                    }
                />

                <BodyValidation
                    click={() => {
                        handleClickNext();
                    }}
                    btnDisabled={btnDisabled}
                    showBtnNext={!showLoader}
                    showBtnPrev={false}
                >
                    <div className="w-100">
                        <StepContainerRequestAccess
                            t={t}
                            navigate={navigate}
                            steps={steps}
                            setSteps={setSteps}
                            visitorList={visitorList}
                            setVisitorList={setVisitorList}
                            employeeList={employeeList}
                            setEmployeeList={setEmployeeList}
                            emptyFields={emptyFields}
                            activeStep={activeStep}
                            setActiveStep={setActiveStep}
                            requestAccessItem={requestAccessItem}
                            photoPickerFile={photoPickerFile}
                            setPhotoPickerFile={setPhotoPickerFile}
                            handleChange={handleChange}
                            showLoader={showLoader}
                        />
                    </div>
                </BodyValidation>
            </ContainerValidation>
        </>
    </>)
}

export default FindMySelfMain
